export class BackendResponse {

    constructor(public status              : number,
                public code                : string,
                public message             : string) {}

}


// WEBPACK FOOTER //
// C:/Users/user/Desktop/otojet-git/OtojetUI-Spring-Admin-Project/src/app/model/backend-response.model.ts